import React from 'react'

export const NotFound = () => <p>Not found</p>

export default NotFound
